export const DEFAULT_COUNTRY = 'United Kingdom'

export const GIBRALTAR_POSTCODE = 'GX111AA'

export interface ApiErrorDetailsResponse {
  status: number
  title: string
  detail: string
  errors: string[]
}

export enum SignUpStatus {
  Complete = 'complete',
  EmailSent = 'emailSent',
}

export interface ApiSignUpStatusResponse {
  signUpStatus: SignUpStatus
}

export interface DonorDetails {
  emailAddress: string
  firstname: string
  lastname: string
  addressLine1: string
  addressLine2: string
  city: string
  county: string
  postcode: string
  country: string
  emailSignature?: string
}

// As DonorDetails with lowercase/non-required property names
export type UrlParamsDonorDetails<T> = {
  [K in keyof T as Partial<Lowercase<K & string>>]: T[K]
}
